import { removeHTMLEntities } from "../util/string"

export type SpaReviewDto = {
  uuid: string;
  spaUUID: string;
  parent_uuid: string;
  date: number;
  author: {
    name: string;
    email: string;
  };
  content: string;
  scores: {
    environment: number;
    service: number;
    customer_service: number;
    value_for_money: number;
  };
};


export class SpaReview {
  constructor(
    public uuid: string,
    public spaUUID: string,
    public parentUuid: string,
    public date: Date,
    public author: {
      name: string,
      email: string,
    },
    public content: string,
    public scores: {
      environment: number,
      service: number,
      customerService: number,
      valueForMoney: number,
    },
  ) { }

  static createEmpty(spaUUID: string): SpaReview {
    return new SpaReview(
      '',
      spaUUID,
      '',
      new Date(),
      {
        name: '',
        email: '',
      },
      '',
      {
        environment: 5,
        service: 5,
        customerService: 5,
        valueForMoney: 5,
      },
    )
  }

  static from(dto: SpaReviewDto): SpaReview {
    return new SpaReview(
      dto.uuid,
      dto.spaUUID,
      dto.parent_uuid,
      new Date(dto.date * 1000),
      {
        name: dto.author.name,
        email: dto.author.email,
      },
      removeHTMLEntities(dto.content),
      {
        environment: dto.scores.environment,
        service: dto.scores.service,
        customerService: dto.scores.customer_service,
        valueForMoney: dto.scores.value_for_money,
      },
    )
  }

  to(): SpaReviewDto {
    const dto = {
      uuid: '',
      spaUUID: this.spaUUID,
      parent_uuid: this.parentUuid,
      date: this.date.getTime() / 1000,
      author: {
        name: this.author.name,
        email: this.author.email,
      },
      content: this.content,
      scores: {
        environment: this.scores.environment,
        service: this.scores.service,
        customer_service: this.scores.customerService,
        value_for_money: this.scores.valueForMoney,
      },
    }

    return dto
  }
}
